import { call, put } from "@redux-saga/core/effects";
import { handleError } from "../../../util/errorHandler";
import {
  GET_ALL_CARD_TYPES,
  GET_CARD_TYPE_CONFIGURATIONS,
  setCardTypeConfigurations,
  setCardTypes,
} from "../../reducers/cardTypeReducer";
import { CardTypeApi } from "../../../generated/api";
import { getAPIConfig } from "../../../util/api-config";
import store from "../../configureStore";
import confirmSaga from "./modalSagas";
import { toast } from "react-toastify";
import i18n from "../../../i18n/i18n";

function setUpClient() {
  return new CardTypeApi(
    getAPIConfig(store.getState().settings.internalSettings)
  );
}

export function* handleGetCardTypes(action: any): any {
  try {
    const cardTypeClient = setUpClient();
    const response = yield cardTypeClient.getCardTypes();
    yield put(setCardTypes(response));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleAddCardType(action: any): any {
  try {
    const cardTypeClient = setUpClient();
    yield cardTypeClient.addCardType(action.cardType);

    yield put({ type: GET_ALL_CARD_TYPES });
    toast.success(String(i18n.t("toasts.cardTypeAdded")));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleDeleteCardTypeModal(action: any): any {
  try {
    const isConfirmed = yield call(confirmSaga, "delete");
    if (isConfirmed) {
      yield call(handleDeleteCardType, action);
    }
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleDeleteCardType(action: any): any {
  try {
    const cardTypeClient = setUpClient();
    yield cardTypeClient.removeCardType(action.cardTypeId);

    yield put({ type: GET_ALL_CARD_TYPES });
    toast.success(String(i18n.t("toasts.cardTypeDeleted")));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleGetAvailableCardTypes(action: any): any {
  try {
    const cardTypeClient = setUpClient();
    const response = yield cardTypeClient.getAvailableCardTypes(
      action.carePrincipalId
    );
    yield put(setCardTypes(response));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleGetCardTypeConfigurations(action: any): any {
  try {
    const cardTypeClient = setUpClient();
    const response = yield cardTypeClient.getCardTypeConfigurations(
      action.carePrincipalId
    );
    yield put(setCardTypeConfigurations(response));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleUpdateCardTypes(action: any): any {
  try {
    const cardTypeClient = setUpClient();
    yield cardTypeClient.updateCardTypeConfiguration(
      action.carePrincipalId,
      action.updateCardTypes
    );
    yield put({
      type: GET_CARD_TYPE_CONFIGURATIONS,
      carePrincipalId: action.carePrincipalId,
    });
    toast.success(String(i18n.t("toasts.cardTypeUpdated")));
  } catch (error) {
    yield handleError(error);
  }
}
